import React from 'react';

interface ErrorMessageProps {
  title: string;
  message: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ title, message }) => (
  <div className="container">
    <div className="errorMessage">
      <h3>{title}</h3>
      <p>{message}</p>
    </div>
  </div>
);